/**
 * RaffleLogo - Simple logo for raffle screen
 * Supports forwardRef for position calculations (rays emanate from logo center)
 */

import { forwardRef } from "react";
import styles from "./RaffleLogo.module.css";

interface RaffleLogoProps {
  /** Size variant */
  size?: "small" | "medium" | "large";
  /** Callback when logo image loads (for position recalculation) */
  onLoad?: () => void;
}

export const RaffleLogo = forwardRef<HTMLImageElement, RaffleLogoProps>(
  function RaffleLogo({ size = "medium", onLoad }, ref) {
    const sizeClass = size === "large" ? styles.large : size === "small" ? styles.small : "";

    return (
      <div className={`${styles.container} ${sizeClass}`}>
        <img
          ref={ref}
          src="/logo.png"
          alt="One Church"
          className={styles.logo}
          onLoad={onLoad}
        />
      </div>
    );
  }
);

export default RaffleLogo;
